import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { debounceTime } from 'rxjs/operators';
import { IDirectoryUserBlockInn, IRatsorgRegistration } from '../../models/domain';
import { PhoneInputComponent } from '../../module/phone-input/phone-input.component';
import { AccountService } from '../../services/account.service';
import { DirectoryService } from "../../services/directory.service";
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { CaptchaComponent } from '../../components/captcha/captcha.component';

@Component({
    selector: 'app-ratsorg-registration',
    templateUrl: './ratsorg-registration.component.html',
    styleUrls: ['./ratsorg-registration.component.css']
})
export class RatsorgRegistrationComponent implements OnInit {
    ratsorgForm: FormGroup;
    regInfo: IRatsorgRegistration;
    blocks: Observable<IDirectoryUserBlockInn[]>;
    blockValue: string = ' ';

    validFIO: boolean = false;
    validInn: boolean = false;
    validBlock: boolean = false;
    validEmail: boolean = false;
    validPhone: boolean = false;
    validbirthdate: boolean = false;
    validUserAgreement: boolean = false;
    validPersonalData: boolean = false;
    lockSubmitButton: boolean = false;
    invalidCaptcha: boolean = false;
    dateNow = new Date();

    selectedFiles: FileList;
    public captchaCode: string;
    private _catchaValidationError: string;

    @ViewChild(PhoneInputComponent, { static: true }) phoneInputComponent: PhoneInputComponent;
    @ViewChild('captchaComponent') captchaComponent: CaptchaComponent;

    constructor(
        private accountService: AccountService,
        private directoryService: DirectoryService,
        private _translateService: TranslateService,
        private router: Router,
        private datePipe: DatePipe,
        private title: Title) {
    }

    ngOnInit(): void {
        this.initForm();
        this._initTranslations();
        this.title.setTitle('Регистрация рацорга')
        this.blocks = this.ratsorgForm.controls["userblockInput"].valueChanges.pipe(
            debounceTime(500),
            switchMap(val => {
                return this.directoryService.getUserBlocks(val || '')
            }),
        );
    }

    private _initTranslations() {
        this._translateService.get(
            [
                'Common.CaptchaValidationError'
            ])
            .subscribe(
                result => {
                    this._catchaValidationError = result['Common.CaptchaValidationError'];
                });
    }

    initForm() {
        this.ratsorgForm = new FormGroup({
            lastName: new FormControl('', Validators.required),
            firstName: new FormControl('', Validators.required),
            middleName: new FormControl('', Validators.required),
            Inn: new FormControl('', Validators.required),
            birthDate: new FormControl('', Validators.required),
            email: new FormControl('', [Validators.required, Validators.email]),
            userAgreement: new FormControl(false, Validators.requiredTrue),
            personalData: new FormControl(false, Validators.requiredTrue),
            userblockInput: new FormControl('', Validators.required),
        })
    }


    displayBlockName(block: IDirectoryUserBlockInn): string {
        return block.name;
    }

    onBlockSelected(option: MatOption) {
        var value: IDirectoryUserBlockInn = option.value;
        this.blockValue = value.id.toString();
        this.ratsorgForm.get('Inn').patchValue(value.inn);
    }

    loadFiles(event: any) {
        for (var i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i].size > 104857600) {
                alert("Файл слишком большой. Пожалуйста, выберите другой.")
                event.target.value = ''
                return
            }
        }
        this.selectedFiles = event.target.files;
    }

    submitRegistration() {
        this.lockSubmitButton = true;
        if (this.ratsorgForm.get('birthDate').value > this.datePipe.transform(new Date(), 'yyyy-MM-dd')) {
            alert('Дата рождения не может быть больше текущей!')
            this.ratsorgForm.get('birthDate').patchValue('')
        }
        if (this.ratsorgForm.get('firstName').errors &&
            this.ratsorgForm.get('firstName').hasError('required') ||
            this.ratsorgForm.get('lastName').errors &&
            this.ratsorgForm.get('lastName').hasError('required') ||
            this.ratsorgForm.get('middleName').errors &&
            this.ratsorgForm.get('middleName').hasError('required')) {
            this.validFIO = true;
        } else { this.validFIO = false }
        if (!(this.phoneInputComponent.phoneValueWithRegion.length > 10)) {
            this.validPhone = true;
        } else { this.validPhone = false }
        if (this.ratsorgForm.get('email').errors &&
            this.ratsorgForm.get('email').hasError('required') ||
            this.ratsorgForm.get('email').hasError('email')) {
            this.validEmail = true;
        } else { this.validEmail = false }
        if (this.ratsorgForm.get('userAgreement').errors || this.ratsorgForm.get('userAgreement').hasError('requiredTrue')) {
            this.validUserAgreement = true
        } else { this.validUserAgreement = false }
        if (this.ratsorgForm.get('personalData').errors || this.ratsorgForm.get('personalData').hasError('requiredTrue')) {
            this.validPersonalData = true
        } else { this.validPersonalData = false }
        if (this.ratsorgForm.get('userblockInput').errors || this.ratsorgForm.get('userblockInput').hasError('required')) {
            this.validBlock = true
        } else { this.validBlock = false }
        if (!this.validInn &&
            !this.validFIO &&
            !this.validPhone &&
            !this.validEmail &&
            !this.validUserAgreement &&
            !this.validPersonalData
            && this.ratsorgForm.valid) {
            this.regInfo = this.ratsorgForm.value
            this.regInfo.phone = this.phoneInputComponent.phoneValueWithRegion
            this.regInfo.captchaCode = this.captchaCode
            this.regInfo.blockId = Number(this.blockValue);
            var formData: FormData = new FormData();
            if (this.selectedFiles != null) {
                for (let i = 0; i < this.selectedFiles.length; i++) {
                    formData.append('files', this.selectedFiles[i])
                }
            }
            formData.append('registrationInfoSerialized', JSON.stringify(this.regInfo))
            this.accountService.ratsorgRegistration(formData).subscribe(res => {
                if (res.success) {
                    alert('Регистрация прошла успешно')
                    window.location.href = './api/v1/Account/redirect-out'
                }
                else if (res.error == "InvalidCaptcha") {
                    this.invalidCaptcha = true;
                    this.captchaComponent.refreshCaptcha();
                    this.lockSubmitButton = false;
                }
                else if (res.error == "EmailExist") {
                    alert('Такой Email уже используется!')
                    this.lockSubmitButton = false;
                    this.captchaComponent.refreshCaptcha();
                }
                else if (res.error == "LoginExist") {
                    alert('Такой номер телефона уже используется!')
                    this.lockSubmitButton = false;
                    this.captchaComponent.refreshCaptcha();
                }
                else {
                    console.error(res.error)
                    alert('Произошла непредвиденная ошибка. Попробуйте снова.')
                    this.invalidCaptcha = false;
                    this.lockSubmitButton = false;
                    this.captchaComponent.refreshCaptcha();
                }
            })
        } else { this.lockSubmitButton = false; return }
    }
}
